import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

class DashboardHome {
  constructor() {
    this._initSwiper();
  }

  _initSwiper() {
    new Swiper('.dashboard-home-coach-actualites__actualites-list', {
      modules: [Pagination, Autoplay],
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      preventInteractionOnTransition: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        640: {
          direction: 'vertical',
        },
      },
    });

    new Swiper('.dashboard-home-methode__list', {
      direction: 'horizontal',
      slidesPerView: 1.2,
      spaceBetween: 20,
      grabCursor: true,
      mousewheel: true,
      preventInteractionOnTransition: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        640: {
          slidesPerView: 2.5,
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
    });
  }
}

export const dashboardHome = new DashboardHome();
